import React from 'react';
import { Button } from '../Button';
import { Section } from '../Section';

export function Security({
  head = 'Your Security, Our Priority',
  body = 'Using advanced encryption and top-tier financial practices, we protect your funds, transactions and personal information every step of the way.',
}) {
  return (
    <div className="tw-relative">
      <Section className="tw-flex tw-flex-col tw-items-center tw-space-y-4 tw-z-10">
        <h2 className="tw-text-center tw-z-10 tw-text-black tw-mb-0">{head}</h2>
        <p className="tw-max-w-3xl tw-text-center tw-z-10">{body}</p>
        <div className="tw-w-full md:tw-w-auto tw-z-10">
          <Button illustrated className="tw-w-full md:tw-w-auto tw-z-10 tw-text-white" href={'/create-link'}>
            Get started
          </Button>
        </div>
      </Section>

      <img
        loading='lazy'
        src="/assets/brand/pod-bg-logo-right.png"
        alt="PayOnDelivery"
        className="tw-absolute tw-bottom-0 tw-left-0 focus-within:tw-max-w-full tw-z-0"
        style={{height: '359.27px', width: '269.06px'}}
      />
    </div>
  );
}
